import { Area, CellPosition } from '../../types';
import { AddressType } from '../../types/sheet/address';
import {
  convertPositionToArea,
  doAreasIntersect,
  getIntersectedArea,
  isAreaInsideArea,
  isEqualAreas,
  mergeAreas,
  reduceAreaByIntersection,
} from '../area/area';
import {
  ParseSingleAddress,
  convertAreaToAddressString,
  parseSingleAddress,
} from './singleAddress';

export const extractSheetAndAddress = (
  address: string,
  defaultSheetId: string
) => {
  if (address.includes('!')) {
    const [refSheetId, adr] = address.split('!');

    const sheet =
      refSheetId.startsWith("'") && refSheetId.endsWith("'")
        ? refSheetId.substring(1, refSheetId.length - 1)
        : refSheetId;

    return {
      sheet,
      address: adr,
    };
  }

  return {
    sheet: defaultSheetId,
    address,
  };
};

// Styles
// ranges: A:A
// type SplitAddressesCB = (params: { address: string; isEqual: boolean }) => {};
export const reduceAddresses = (
  addresses: string[],
  newAddress: string,
  maxColIndex: number,
  maxRowIndex: number
  // cb: () => void
) => {
  const addressToAdd = parseSingleAddress(newAddress);

  const newArea = convertParsedAddressToArea(
    addressToAdd,
    maxColIndex,
    maxRowIndex
  );

  const newAreas: Area[] = [];

  // addresses.forEach((address) => {
  for (const address of addresses) {
    const parsed = parseSingleAddress(address);

    const area = convertParsedAddressToArea(parsed, maxColIndex, maxRowIndex);

    // if (isAreaInsideArea(newArea, area)) {
    // }

    if (isEqualAreas(area, newArea)) {
      // Skip do not return
      continue;
    }

    const intersection = getIntersectedArea(area, newArea);
    if (intersection) {
      newAreas.push(...reduceAreaByIntersection(area, intersection));
      continue;
    }

    newAreas.push(area);
  }

  return newAreas.map((area) =>
    convertAreaToAddressString(area, maxColIndex, maxRowIndex)
  );
};

// Filter on data validations and number formats addresses and call split areas if after splitting area
// Is empty then delete that data validation and number format

export const convertParsedAddressToArea = (
  parsedAddres: ParseSingleAddress,
  maxColIndex: number,
  maxRowIndex: number
) => {
  switch (parsedAddres.type) {
    case AddressType.Column: {
      const { range } = parsedAddres;
      return {
        start: { ci: range.start, ri: 0 },
        end: { ci: range.end, ri: maxRowIndex },
      };
    }
    case AddressType.Row: {
      const { range } = parsedAddres;
      return {
        start: { ri: range.start, ci: 0 },
        end: { ri: range.end, ci: maxColIndex },
      };
    }
    case AddressType.Position:
      return convertPositionToArea(parsedAddres.position);
    case AddressType.Range:
      return parsedAddres.area;
  }
};

// export const convertAddressToArrayAreaAddress = (address: string) => {
//   const parsed = parseSingleAddress(address)
//   switch(parsed.type) {
//     case AddressType.Position:
//       const { ri, ci } = parsed.position
//       return `${ri},${ci}`;
//     case AddressType.Column:
//       const range = parsed.range
//       return `${null}`
//   }

// }

export const isCellInsideRangeAddress = (
  range: string,
  cellArea: Area,
  maxColIndex: number,
  maxRowIndex: number
) => {
  const rangeArea = convertParsedAddressToArea(
    parseSingleAddress(range),
    maxColIndex,
    maxRowIndex
  );

  return isAreaInsideArea(cellArea, rangeArea);
};

export const isAddressUnderAddress = (
  innerAddress: string,
  outerAddress: string,
  maxColIndex: number,
  maxRowIndex: number
) => {
  const innerArea = convertParsedAddressToArea(
    parseSingleAddress(innerAddress),
    maxColIndex,
    maxRowIndex
  );

  const outerArea = convertParsedAddressToArea(
    parseSingleAddress(outerAddress),
    maxColIndex,
    maxRowIndex
  );

  return isAreaInsideArea(innerArea, outerArea);
};

export const removeAddressFromRangeMatrix = (
  rangesMatrix: string[][],
  area: Area,
  address: string
) => {
  for (let c = area.start.ci; c <= area.end.ci; c++) {
    const columnMatrix = rangesMatrix[c];
    if (columnMatrix.length) {
      const newColumnMatrix = columnMatrix.filter((range) => range !== address);
      if (newColumnMatrix.length) {
        rangesMatrix[c] = newColumnMatrix;
      } else {
        delete rangesMatrix[c];
      }
    }
  }
};

export const addAddressToRangeMatrix = (
  rangesMatrix: string[][],
  area: Area,
  address: string // Can be of form A1:C1 etc OR `0,0,1,2`
) => {
  for (let c = area.start.ci; c <= area.end.ci; c++) {
    if (!rangesMatrix[c]) rangesMatrix[c] = [];
    rangesMatrix[c].push(address);
  }
};

